import {Injectable} from '@angular/core';

import {Http, Response}  from '@angular/http';
import {AuthHttp, AuthConfig} from 'angular2-jwt';

import {Observable}  from 'rxjs/Observable';
// import 'rxjs/add/observable/throw';

import {StoreService}  from '../store/store.service';
import {CognitoAuthService} from '../auth/cognito.service';

@Injectable()
export class EventService {

    events: any[ ] = [];
    maxEventDataCallRetries = 3;
    eventsDataSubscription;

    idToken: string;
    customer: string;
    eventIds: string;
    eventIdsCount: number;

    private static extractData(res: Response) {
        let body = res.json();
        return body || [];
    }

    private static handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead

        return Observable.throw(errMsg);
    }

    constructor(private store: StoreService, private http: Http, private authHttp: AuthHttp, private cognitoAuthService: CognitoAuthService) {
        this.eventIds = '';
        this.eventIdsCount = 0;
    }

    // getEvents(eventIds = '', areEventsForAlerts: boolean = false): Observable<any>{
    getEvents(params, forceFetchEventsFromAPI = false): Observable<any> {

        const self = this;

        return Observable.create(function (subscriber) {

            // If the events being fetched from API are for alerts, then the prop in the store will be 'eventsForAlerts', else just 'events'
            const storeProp = params.areEventsForAlerts ? 'eventsForAlerts' : 'events';
            const storeParamsProp = params.areEventsForAlerts ? 'eventsForAlertsParams' : 'eventsParams';

            let doFetchEventsFromAPI = false;

            if ((!self.store.isFresh()) || forceFetchEventsFromAPI) {

                // console.log('Store is NOT FRESH!');
                self.store.delete(storeParamsProp);
                self.store.delete(storeProp);
                doFetchEventsFromAPI = true;
            } else {

                const storeEvents = self.store.get(storeProp);

                // console.log('storeEvents.length !== 0', (storeEvents.length !== 0) );

                const storeEventsParams = self.store.get(storeParamsProp);

                let index = -1;
                const paramsPresent = storeEventsParams.some(function (p) {
                    ++index;
                    return JSON.stringify(p) === JSON.stringify(params);
                });

                // console.log('paramsPresent = ', paramsPresent);
                // console.log('index = ', index);


                if ((storeEvents.length !== 0) && (paramsPresent)) {

                    const events = storeEvents[index];

                    // console.log('events at index = ' + index, events);

                    if (events == null) {

                        // console.log('events are NULL at index = ' + index, events);

                        doFetchEventsFromAPI = true;
                    } else {

                        // console.log('Retrieving events from STORE');
                        // console.log('storeEvents = ', storeEvents);
                        // console.log('storeEventsParams = ', storeEventsParams);
                        // console.log('================');

                        subscriber.next(events);
                    }
                } else {
                    doFetchEventsFromAPI = true;
                }

            }

            // Fetch events from the API only if the events in the store on client are not fresh
            // i.e. if they are older than the life of the store
            if (doFetchEventsFromAPI) {

                self.cognitoAuthService.getIdTokenPromise().then(function (idToken) {

                    self.idToken = idToken;
                    self.customer = self.cognitoAuthService.decodeToken(idToken)['custom:customer'];
                    self.eventIds = params.eventIds;
                    self.eventIdsCount = (params.eventIds) ? 1 + (params.eventIds.match(/,/g) || []).length : 0;
                    if (self.eventIdsCount < 100) {
                        self.eventIdsCount = 100; // min default value
                    }

                    self.eventsDataSubscription = self.callEventsApi(params).subscribe(function (events) {

                        events.forEach(function (event) {
                            event.event_ts = new Date(event.event_ts);
                            if (isNaN(event.event_ts.getTime())) {
                                event.event_ts = new Date(event.end_ts);
                            }
                            event.event_ts = event.event_ts.toLocaleDateString('en-US')+" "+event.event_ts.toLocaleTimeString('en-US', { hour12: false });
                            //event.event_ts = event.event_ts.substring(0, 19).replace('T', ' ');
                        });

                        self.events = events;
                        self.store.add(storeParamsProp, params);
                        self.store.add(storeProp, events);
                        self.store.refresh();

                        // console.log('Got fresh events from API');
                        // console.log('events', self.store.get('events'));
                        // console.log('eventsParams', self.store.get('eventsParams'));
                        // console.log('================');

                        subscriber.next(events);

                    }, function (err) {

                        self.events = [];

                        // Retry fetching events until max number of retries is reached
                        self.eventsDataSubscription.unsubscribe();
                        --self.maxEventDataCallRetries;
                        if (self.maxEventDataCallRetries > 0) {
                            self.getEvents(params);
                        }
                    });
                }).catch(function (err) {

                    console.log('Error in getIdTokenPromise()');
                    console.log(err);

                });
            }
        });
    }

    private callEventsApi(params): Observable<any> {

        // TODO: Use params to fetch filtered events from AWS instead of fetching all events

        const json_token = {
            event_ids: this.eventIds,
            range: params.timePeriod,
            ip: params.ip,
            limit: this.eventIdsCount
        };

        const apiConfig = this.store.get('apiConfig');
        apiConfig.headers["Authorization"] = this.idToken;

        // Mock request to a static events data file
        // return this.http.get('assets/data/events.json').map(EventService.extractData).catch(EventService.handleError);

        return this.http.post(apiConfig.eventsURL,
            JSON.stringify(json_token), {headers: apiConfig.headers})
            .map(EventService.extractData)
            // .map(res => res.json())
            .catch(EventService.handleError);

    }
}



// WEBPACK FOOTER //
// /app/src/app/shared/event/event.service.ts